module.exports = __webpack_public_path__ + "static/media/fringes.6ce35048.jpg";